import axios from '../utils/axios';

const autoApplyQueueApi = {
	getCounts: async () => {
		const result = await axios.get('/api/auto-apply/queue/counts');

		return result.data.data;
	},

	getQueue: async () => {
		const result = await axios.get('/api/auto-apply/queue');

		return {
			applications: result.data.data,
			counts: result.data.meta.counts,
			completeAutoApply: result.data.meta.complete_auto_apply === true,
		};
	},

	setCompleteAutoApply: async (enabled) => {
		const result = await axios.put('/api/job-board/settings/complete-auto-apply', {
			complete_auto_apply: enabled,
		});

		return result.data.data.complete_auto_apply;
	},

	addToQueue: async ({ jobBoardJobId, resumeUuid, queryId = null, source = null }) => {
		const result = await axios.post('/api/auto-apply/queue', {
			job_board_job_id: jobBoardJobId,
			resume_uuid: resumeUuid,
			query_id: queryId,
			source,
		}, {
			validateStatus: () => true,
		});

		return result;
	},

	// The answers under review, and the resume they were prepared from (null when the server names none).
	getAnswers: async (uuid) => {
		const result = await axios.get(`/api/auto-apply/queue/${uuid}/answers`);

		return { answers: result.data.data, resumeUuid: result.data.meta?.resume_uuid ?? null };
	},

	// What View Details shows for a sent application (EN-1247): what the send put on the form, or what was prepared
	// for an application marked as applied.
	getDetails: async (uuid) => {
		const result = await axios.get(`/api/auto-apply/queue/${uuid}/details`);

		return result.data.data;
	},

	fetchDetailsDocumentBlob: async (uuid, type) => {
		const result = await axios.get(`/api/auto-apply/queue/${uuid}/details/documents/${type}`, {
			responseType: 'blob',
		});

		return result.data;
	},

	// Submit Application. Answers with the pending application and the counts it changed.
	submit: async (uuid) => {
		const result = await axios.post(`/api/auto-apply/queue/${uuid}/submit`);

		return { application: result.data.data, counts: result.data.meta.counts };
	},

	// Cancel Send. Answers with the application back in review and the counts it changed.
	cancelSend: async (uuid) => {
		const result = await axios.post(`/api/auto-apply/queue/${uuid}/cancel-send`);

		return { application: result.data.data, counts: result.data.meta.counts };
	},

	changeResume: async (uuid, resumeUuid) => {
		const result = await axios.post(`/api/auto-apply/queue/${uuid}/change-resume`, { resume_uuid: resumeUuid });

		return result.data.data;
	},

	applyUntailored: async (uuid) => {
		const result = await axios.post(`/api/auto-apply/queue/${uuid}/apply-untailored`);

		return result.data.data;
	},

	removeFromQueue: async (uuid) => {
		const result = await axios.delete(`/api/auto-apply/queue/${uuid}`);

		return { application: result.data.data, counts: result.data.meta.counts };
	},

	markApplied: async (uuid) => {
		const result = await axios.post(`/api/auto-apply/queue/${uuid}/mark-applied`);

		return { application: result.data.data, counts: result.data.meta.counts };
	},

	resubmit: async (uuid) => {
		const result = await axios.post(`/api/auto-apply/queue/${uuid}/resubmit`);

		return { application: result.data.data, counts: result.data.meta.counts };
	},

	reportIssue: async (uuid, { message, platform }) => {
		await axios.post(`/api/auto-apply/queue/${uuid}/report`, { message, platform });
	},
};

export default autoApplyQueueApi;
